var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "btn-group" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-default btn-sm",
        attrs: {
          type: "button",
          disabled: _vm.downloadInProgress || _vm.disabled,
          title: _vm.downloadInProgress
            ? "Downloading..."
            : "Export results as a CSV file",
        },
        on: {
          click: function ($event) {
            return _vm.downloadCsv(false)
          },
        },
      },
      [
        _vm.downloadInProgress
          ? [
              _vm._v(" "),
              _c("span", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" "),
            ]
          : _vm._e(),
        _vm._v("Export\n\t"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-default btn-sm",
        attrs: {
          type: "button",
          disabled: _vm.downloadInProgress || _vm.disabled,
          title: _vm.downloadInProgress
            ? "Downloading..."
            : "Export Results as a CSV file for use with Excel",
        },
        on: {
          click: function ($event) {
            return _vm.downloadCsv(true)
          },
        },
      },
      [
        _vm.downloadInProgress
          ? [
              _vm._v(" "),
              _c("span", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" "),
            ]
          : _vm._e(),
        _vm._v("Export for Excel\n\t"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }